import {
  skelBorderRadius,
  skeletonStyles,
  skelHeight,
  skelWidth,
} from "./skeleton.css";
import { assignInlineVars } from "@vanilla-extract/dynamic";

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
}

const Skeleton = ({
  width,
  height = "16px",
  borderRadius = "16px",
}: SkeletonProps) => {
  return (
    <div
      className={skeletonStyles}
      style={assignInlineVars({
        [skelWidth]: width,
        [skelHeight]: height,
        [skelBorderRadius]: borderRadius,
      })}
    />
  );
};

export default Skeleton;
